import { createApp } from "vue";
import Router from "@/router/Router";
import MaatComputers from "@/MaatComputers.vue";

createApp(MaatComputers).use(Router).mount("#maatcomputers");
